((function ($) {
  if (!$.uniqBase) {
    $.uniqBase = {};
  }

  $.uniqBase.StickySidebar = function (el, options) {
    // To avoid scope issues, use 'base' instead of 'this'
    // to reference this class from internal events and functions.
    var base = this;

    // Access to jQuery and DOM versions of element
    base.$el = $(el);
    base.el = el;

    // Add a reverse reference to the DOM object
    base.$el.data('uniqBase.StickySidebar', base);

    base.init = function () {
      base.options = $.extend({},
        $.uniqBase.StickySidebar.defaultOptions, options);
      base.initScroll();
    };
    base.init();
  };

  /**
   * @method initScroll
   * @desc initialize scroll event
   */
  $.uniqBase.StickySidebar.prototype.initScroll = function () {
    var base = this;

    /*
      base.sticky.position:
      - none: default
      - fixed: container is sticky
      - bottom: container stops at the bottom of wrapper-container
     */
    base.sticky = {
      isSticky: false,
      position: 'none'
    };
    base.wrapperContainer = base.$el.closest(base.options.wrapperContainer).get(0);
    base.stickyAt = $(base.options.setStickyAt).height() + $(base.options.setStickyAt).position().top + base.options.offsetTop;

    base.stopAt = base.$el.height() + base.stickyAt + base.options.offsetTop;
    base.el.parentElement.setAttribute('style', 'display:flex; flex-direction:column');
    base.stickyWidth = '100%';

    if (typeof base.options.beforeInit === 'function') {
      base.options.beforeInit.call(this, base);
    }

    $(document).on('ready', function () {
      base.checkPosition();
    });

    $(window).on('scroll load', function () {
      base.checkPosition();
    });

    $(window).on('resize', function () {
      base.resizeSticky();
    });
  };

  /**
   * @method checkposition
   * @desc Checks position of base.el and set sticky or not
   */
  $.uniqBase.StickySidebar.prototype.checkPosition = function () {
    var base = this;
    var offSetTop = base.el.parentElement.getBoundingClientRect().top;

    base.resizeSticky();
    if (base.wrapperContainer.getBoundingClientRect().bottom < base.stopAt && base.sticky.initialCall) {
      base.$el.css({
        position: 'relative',
        top: $(base.wrapperContainer).height() - base.$el.height(),
        width: base.stickyWidth
      });
      base.sticky.initialCall = false;

      return;
    }
    // scrolling top -> bottom (set fixed when offset matches)
    if (offSetTop < base.stickyAt && !base.sticky.isSticky && (offSetTop > 0 || base.fastScrolling) && base.sticky.position === 'none') {
      base.fastScrolling = false;

      if (typeof base.options.setSticky === 'function') {
        base.options.setSticky.call(this, base);
      } else {
        base.$el.css({
          position: 'fixed',
          top: base.stickyAt,
          width: base.stickyWidth
        });
      }

      base.sticky.isSticky = true;
      base.sticky.position = 'fixed';
      // scrolling bottom -> top (to start position)
    } else if ((offSetTop > base.stickyAt && base.sticky.isSticky && base.sticky.position === 'fixed') || ($(document).scrollTop() <= base.stickyAt && base.sticky.isSticky === false)) {
      if (typeof base.options.initialPosition === 'function') {
        base.options.initialPosition.call(this, base);
      } else {
        base.$el.removeAttr('style');
      }

      base.sticky.isSticky = false;
      base.sticky.position = 'none';

      // scrolling top -> bottom (stopping at the end of wrapper-container)
    } else if (base.wrapperContainer.getBoundingClientRect().bottom < base.stopAt && (base.sticky.isSticky || base.sticky.position)) {
      if (typeof base.options.stopAtBottom === 'function') {
        base.options.stopAtBottom.call(this, base);
      } else {
        base.$el.css({
          position: 'relative',
          top: $(base.wrapperContainer).height() - base.$el.height(),
          width: base.stickyWidth
        });
      }

      base.sticky.isSticky = false;
      base.sticky.position = 'bottom';

      // scrolling bottom -> top
    } else if (base.sticky.position === 'bottom' && base.wrapperContainer.getBoundingClientRect().bottom > base.stopAt) {
      if (typeof base.options.scrollBottomUp === 'function') {
        base.options.scrollBottomUp.call(this, base);
      } else {
        base.$el.css({
          position: 'fixed',
          top: base.stickyAt,
          width: base.stickyWidth
        });
      }

      base.sticky.isSticky = true;
      base.sticky.position = 'fixed';
    } else if ((!base.sticky.isSticky) && Math.abs(offSetTop - base.stickyAt) > base.stickyAt) {
      base.fastScrolling = true;
    }
  };

  /**
   * @method checkposition
   * @desc Checks position of base.el and set sticky or not
   */
  $.uniqBase.StickySidebar.prototype.resizeSticky = function () {
    var base = this;

    if (base.stickyWidth !== $(base.el.parentElement).width()) {
      base.stickyWidth = $(base.el.parentElement).width();
      base.$el.css({
        width: base.stickyWidth
      });
    }
  }

  $.uniqBase.StickySidebar.defaultOptions = {
    setStickyAt: '#main-nav-wrapper-desktop',
    stickyAtPosition: 'top',
    beforeInit: null,
    scrollBottomUp: null,
    stopAtBottom: null,
    initialPosition: null,
    setSticky: null,
    wrapperContainer: '.container',
    offsetTop: 0
  };

  $.fn.uniqBase_stickySidebar = function (options) {
    return this.each(function () {
      (new $.uniqBase.StickySidebar(this, options));
    });
  };
})(jQuery));
